<template>
  <h1>Not found :(</h1>
</template>

<style>
h1 {
  font-size: 100px;
  padding: 50px;
}
</style>